export default "__VITE_ASSET__BUfgfs7z__"